import CustomTabs from '@Modules/core/components/customTab/CustomTabs';
import BatchesListMixedHandlers from '../containers/mixedHandlers/batchProcessing/BatchesListMixedHandlers';

const BatchProcessingPage = () => {
  return (
    <CustomTabs
      tabHeaders={['Batches List']}
      tabContents={[<BatchesListMixedHandlers />]}
    />
  );
};

export default BatchProcessingPage;
